/**
 * Normaliza un valor proveniente de `route.query` o `route.params` a un único string.
 * @param value - Valor crudo del router; puede ser texto, arreglo, null o undefined.
 * @returns El primer valor como string recortado, o cadena vacía si no hay valor utilizable.
 */
export function firstRouteValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return firstRouteValue(value[0]);
  return String(value).trim();
}
